export const USER_ANNOUNCEMENT_SET_DATA = 'USER_ANNOUNCEMENT_SET_DATA';
export const USER_ANNOUNCEMENT_SET_DATANEW = 'USER_ANNOUNCEMENT_SET_DATANEW';
export const USER_ANNOUNCEMENT_SET_LAST_PAGE =
  'USER_ANNOUNCEMENT_SET_LAST_PAGE';
export const USER_ANNOUNCEMENT_SET_TOTAL_ROWS =
  'USER_ANNOUNCEMENT_SET_TOTAL_ROWS';
export const USER_ANNOUNCEMENT_SET_RELOAD_DATA =
  'USER_ANNOUNCEMENT_SET_RELOAD_DATA';
export const USER_ANNOUNCEMENT_SET_LOADING = 'USER_ANNOUNCEMENT_SET_LOADING';
